class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('select[name="country_code"], select[name="language_code"]')
    };

    this.querySelectorAll('select').forEach(item => item.addEventListener('change', this.onItemChange.bind(this)));
  }

  onItemChange(event) {
    const form = this.querySelector('form');
    if (form) form.submit();
  }
}

customElements.define('localization-form', LocalizationForm);
